import React, { useState } from "react";
import RangeCalendar from "./RangeCalendar";

function CalendarPopup({ dates, onClose, onSave }) {
  const [mode, setMode] = useState(dates?.date_2 ? "range" : "single");

  const [range, setRange] = useState({
    start: dates?.date_1 || null,
    end: dates?.date_2 || null,
  });

  return (
    <div style={{ padding: 16, width: "max-content" }}>
      {/* RADIO MODE SELECTOR */}
      <div className="calendar-mode-switch">
        <label>
          <input
            style={{
              all:"initial",
              appearance: "auto",
              marginRight: "8px", // 👈 gap here
              cursor: "pointer",
            }}
            className="calendar_mode"
            type="radio"
            name="calendar_mode"
            value="single"
            checked={mode === "single"}
            onChange={() => {
              setMode("single");
              setRange((r) => ({ start: r.start, end: null }));
            }}
          />
          Single Date
        </label>

        <label>
          <input
            style={{
              all:"initial",
              appearance: "auto",
              marginRight: "8px", // 👈 gap here
              cursor: "pointer",
            }}
            className="calendar_mode"
            type="radio"
            name="calendar_mode"
            value="range"
            checked={mode === "range"}
            onChange={() => setMode("range")}
          />
          Date Range
        </label>
      </div>

      <RangeCalendar
        value={range}
        min={dates.minDate}
        showSelector={false}
        mode={mode}
        onChange={(r) => setRange(r)}
      />

      <div style={{ marginTop: 16, textAlign: "right" }}>
        <button onClick={onClose}>Cancel</button>
        <button
          style={{ marginLeft: 8 }}
          onClick={() => {
            onSave(range.start, mode === "range" ? range.end : null);
            onClose();
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
}

export default CalendarPopup;
